export class AddRestoreAtlasPrivateLinkRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcEndpointId",
            "baseName": "vpcEndpointId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AddRestoreAtlasPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
